import { useCallback, useRef } from 'react';

/**
 * react-select: tabSelectsValue confirma com TAB; blur após seleção evita segundo TAB para sair do campo (single e multi).
 */
export function useReactSelectTabBlur() {
  const selectRef = useRef(null);

  const onKeyDown = useCallback((event) => {
    if (event.key !== 'Tab' || event.shiftKey) return;

    const instance = selectRef.current;
    const state = instance?.state;
    if (state?.menuIsOpen && state?.focusedOption != null) {
      requestAnimationFrame(() => {
        instance?.blur?.();
      });
    }
  }, []);

  return {
    selectRef,
    tabSelectsValue: true,
    onKeyDown,
  };
}
